import { UserPlus, ListChecks, ScanSearch, FileBadge } from "lucide-react";

const STEPS = [
  { icon: UserPlus, title: "Register", text: "Create your secure CareerStudy360 profile." },
  { icon: ListChecks, title: "Complete the Assessment", text: "Work through carefully designed questions and problem-solving activities." },
  { icon: ScanSearch, title: "Your Profile Is Evaluated", text: "Multiple dimensions are analysed together." },
  { icon: FileBadge, title: "Discover Your CareerStudy360", text: "Receive a comprehensive report covering personality, strengths, work style and career possibilities." },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="bg-white py-24 px-6">
      <div className="max-w-6xl mx-auto">
        <p className="text-xs uppercase tracking-[0.2em] font-medium text-indigo-600 mb-3 text-center">How It Works</p>
        <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900 text-center mb-16">
          Four Steps to a Broader Picture of Your Future
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {STEPS.map((s, i) => (
            <div key={s.title} className="relative" data-testid={`how-it-works-step-${i + 1}`}>
              <div className="flex items-center gap-3 mb-4">
                <div className="h-10 w-10 rounded-full bg-indigo-600 text-white flex items-center justify-center font-heading font-bold">{i + 1}</div>
                <s.icon className="h-6 w-6 text-indigo-500" />
              </div>
              <h3 className="font-heading text-lg font-semibold text-slate-900 mb-2">{s.title}</h3>
              <p className="text-sm text-slate-500 leading-relaxed">{s.text}</p>
            </div>
          ))}
        </div>
        <p className="text-center text-sm text-slate-400 mt-14">
          Estimated time: approximately 35–45 minutes · Progress is saved automatically
        </p>
      </div>
    </section>
  );
}
